import Stripe from 'stripe';

/**
 * Check if plan is an enterprise plan.
 *
 * Lives outside PlansUtils so leaf components can use it without pulling in
 * PlansUtils' Formatters/API import chain (which breaks module-load order in
 * jest). PlansUtils re-exports it, so both import paths resolve to this one
 * implementation.
 *
 * Mirrors backend stripe_cli.IsEnterprisePlan: legacy IDs carry an "_ent"
 * marker, catalog prices are prefixed "enterprise" (e.g.
 * enterprise_platform_annual_24000).
 * @param price stripe price item to check
 */
export const isEnterprisePlan = (price?: Stripe.Price) => {
  const currentPlanId = price?.id;

  return Boolean(
    currentPlanId &&
      (currentPlanId.includes('_ent') ||
        currentPlanId.startsWith('enterprise')),
  );
};
